import { Box } from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import GetBranchDetails from "../../CustomComponents/GetBranchDetails";
import StlapFooter from "../../CustomComponents/StlapFooter";
import { BranchAction } from "../../Store/Branch";
import FilterCondition from "./FilterCondition";
import SanctionedList from "./SanctionedList";
import { CommonShortCutAction } from "../../Store/CommonShortCutsReducer";
import { useRef } from "react";
import GetBranchDetailsWithCode from "../../CustomComponents/GetBranchDetailsWithCode";

var today = new Date();

const initialState = {
  tabIndex: "2",
  disbursementList: [],
  sanctionList: [],
  branchNames: [],
  branch: null,
  applicationNum: "",
  loanType: "",
  customerName: "",
  coApplicantName: "",
  customerId: "",
  sanctionStatus: "",
  effectiveDate: dayjs(
    today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear()
  ).format("DD/MM/YYYY"),
  applicationDateFromValue: dayjs(
    today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear()
  ).format("DD/MM/YYYY"),
  applicationDateToValue: dayjs(
    today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear()
  ).format("DD/MM/YYYY"),
  applicationDate: null,
  customerType: "-1",
  rateOfInterest: "",
  loanAmt: "",
  sanctionAmt: "",

  disbursementDateFromValue: null,
  disbursementDateToValue: dayjs(
    today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear()
  ).format("DD/MM/YYYY"),
  disbursementStatus: "",
  referenceNumber: "",
  screenModeTitle: "",
  // default sort to be in applicationnum.
  sortConditions: [],
};

const DisbursementCreatePortal = (props) => {
  const [accordianOpen, setAccordianOpen] = useState(true);
  const [searchValues, setSearchValues] = useState(initialState);
  const [branchNames, setTotalBranchNames] = React.useState([]);
  const [filterConditionState, setFilterConditionState] =
    React.useState(initialState);
  const dispatch = useDispatch();

  const searchButtonRef = useRef(null);
  const clearRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);

  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let refList = { searchButtonRef: searchButtonRef, clearRef: clearRef };
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.getShortCutValue({
          event: event,
          refs: refList,
          screen: "filterCondition",
        })
      );
      //}
    }
  };
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "filterCondition",
        })
      );
    }
  };

  const navigate = useNavigate();

  const searchButtonClickHandler = (data) => {
    setSearchValues(data);
    filterData(data);
  };

  const getSelectedBranchCodes = (branchValues) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValues = branchWithCodes
      .filter((branch) => branchValues.includes(branch.label))
      .map((branch) => branch.code);
    return branchCodeValues;
  };

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const filterData = async (data) => {
    let filterrows = [];
    // reset the autofill & retain back later.
    updateFilterAutoFill(initialState);
    switch (data.tabIndex) {
      // for this filter use the disbursement list field on state since it contains all the sancation records all time.
      case "2":
        // get the data from backend & use offset case also.
        let filterCondition = {};
        createFilterCondition(filterCondition, data);
        // filterCondition.offset = Math.floor([...data.sanctionList].length / 10);
        filterCondition.offset = 0;
        filterCondition.pageSize = 10;
        filterCondition.column =
          data.sortConditions.length > 0 ? data.sortConditions[0].field : null;
        filterCondition.sort =
          data.sortConditions.length > 0 ? data.sortConditions[0].sort : null;
        // when branch is single & empty -> trigger all the branches.
        filterCondition.branch =
          filterCondition.branch.length === 1 &&
          filterCondition.branch[0] !== null &&
          filterCondition.branch[0] !== undefined &&
          filterCondition.branch[0] !== ""
            ? filterCondition.branch
            : data.branchNames.map((name) => name.label);
        const branchValues = [...filterCondition.branch];
        const branchCodes = getSelectedBranchCodes(branchValues);
        filterCondition.branchCode = branchCodes;
        const response = await axios.post(
          "/losCustomer/getCustomerDataWithPage",
          filterCondition
        );
        let responseDataRows = response.data.content;
        if (data.branch && data.branch !== "") {
          filterrows = [...responseDataRows].filter(
            (row) => row.branchCode === getSelectedBranchCode(data.branch)
          );
          filterConditionState.branch = data.branch;
        } else {
          filterConditionState.branch = "";
        }
        if (data.applicationNum && data.applicationNum !== "") {
          filterrows = filterrows.filter(
            (row) => row.applicationNum === data.applicationNum
          );
          // since this filter is for sancation list, so 1  application number has only one record.
          updateFilterAutoFill(filterrows[0]);
        } else {
          // when app no not filled, means search operated with other individual fields.
          // reset all.
          updateFilterAutoFill(initialState);
        }
        if (data.customerName && data.customerName !== "") {
          filterrows = filterrows.filter(
            (row) => row.customerName === data.customerName
          );
          filterConditionState.customerName = data.customerName;
        }
        if (
          data.rateOfInterest &&
          data.rateOfInterest !== "" &&
          Number(data.rateOfInterest) !== 0
        ) {
          filterrows = filterrows.filter(
            (row) => String(row.rateOfInterest) === String(data.rateOfInterest)
          );
          filterConditionState.rateOfInterest = data.rateOfInterest;
        }
        // if (data.loanAmt && data.loanAmt !== "" && Number(data.loanAmt) !== 0) {
        //   filterrows = filterrows.filter(
        //     (row) => String(row.loanAmt) === String(data.loanAmt)
        //   );
        //   filterConditionState.loanAmt = data.loanAmt;
        // }
        if (
          data.sanctionAmt &&
          data.sanctionAmt !== "" &&
          Number(data.sanctionAmt) !== 0
        ) {
          filterrows = filterrows.filter(
            (row) => String(row.sanctionAmt) === String(data.sanctionAmt)
          );
          filterConditionState.sanctionAmt = data.sanctionAmt;
        }
        const applicationDate = data.applicationDate
          ? dayjs(data.applicationDate).format("DD/MM/YYYY")
          : data.applicationDate;
        if (applicationDate && applicationDate !== "") {
          filterrows = filterrows.filter(
            (row) =>
              dayjs(row.applicationDate).format("DD/MM/YYYY") ===
              applicationDate
          );
          filterConditionState.applicationDate = data.applicationDate;
        } else {
          filterConditionState.applicationDate = null;
        }
        filterConditionState.sanctionList = [...filterrows];
        setFilterConditionState({ ...filterConditionState });
        break;
      default:
        break;
    }
  };

  const createFilterCondition = (filterCondition, filterConditionStateData) => {
    filterCondition.applicationNum = filterConditionStateData.applicationNum;
    filterCondition.branch = [
      filterConditionState.branchNames.length === 1
        ? filterConditionState.branchNames.at(0).label
        : filterConditionStateData.branch,
    ];
    // on single default branch add that value.
    filterConditionStateData.branch =
      filterConditionState.branchNames.length === 1
        ? filterConditionState.branchNames.at(0).label
        : filterConditionStateData.branch;
    filterCondition.applicantName = filterConditionStateData.customerName;
    filterCondition.sanctionAmt = filterConditionStateData.sanctionAmt;
    filterCondition.applicationDate = filterConditionStateData.applicationDate;
  };

  const updateFilterAutoFill = (data) => {
    // this method updates or removes other fields auto fill data to retain back
    filterConditionState.applicationNum = data.applicationNum;
    filterConditionState.customerName = data.customerName;
    filterConditionState.customerType = data.customerType;
    filterConditionState.rateOfInterest = data.rateOfInterest;
    filterConditionState.loanAmt = data.loanAmt;
    filterConditionState.sanctionAmt = data.sanctionAmt;
    filterConditionState.applicationDate = dayjs(data.applicationDate).format(
      "DD/MM/YYYY"
    );
  };

  const resetFilterData = () => {
    filterConditionState.branch = "";
    updateFilterAutoFill(initialState);
    getSanctionList();
  };

  useEffect(() => {
    const loadBranchNames = GetBranchDetails();
    setTotalBranchNames(loadBranchNames);
    filterConditionState.branchNames = loadBranchNames;
    getSanctionList();
  }, []);

  const clearButtonClickHandler = (data) => {
    resetFilterData();
  };

  const rowDoubleClickHandler = (data) => {
    navigate("/stlap/home/disbursementCreate", { replace: true, state: data });
  };

  const getSanctionList = async () => {
    let filterCondition = {};
    createFilterCondition(filterCondition, filterConditionState);
    filterCondition.offset = 0;
    filterCondition.pageSize = 10;
    filterCondition.branch = branchNames.map((name) => name.label);
    let newAxiosBase = { ...axios };
    newAxiosBase.defaults.baseURL = process.env.REACT_APP_STLAP_LMS_BACKEND;
    const branchValues = [...filterCondition.branch];
    const branchCodes = getSelectedBranchCodes(branchValues);
    filterCondition.branchCode = branchCodes;
    const response = await newAxiosBase.post(
      "/losCustomer/getCustomerDataWithPage",
      filterCondition
    );
    const dataMap = [...response.data.content];
    filterConditionState.sanctionList = dataMap;
    const allDataResponse = await axios.get("/losCustomer/getAllData");
    filterConditionState.disbursementList = [...allDataResponse.data];
    filterConditionState.screenModeTitle = props.screenTitle;
    setFilterConditionState({ ...filterConditionState });
    // if branch is one filter for that branch alone for below.
    if (filterConditionState.branchNames.length === 1) {
      const branchValue = filterConditionState.branchNames[0].label;
      loadDataonBranchChange(branchValue);
    }
  };

  const loadDataonBranchChange = async (branchValue) => {
    if (branchValue) {
      let filterCondition = {};
      createFilterCondition(filterCondition, initialState);
      filterCondition.branch = [branchValue];
      filterCondition.offset = 0;
      filterCondition.pageSize = 10;
      const branchValues = [...filterCondition.branch];
      const branchCodes = getSelectedBranchCodes(branchValues);
      filterCondition.branchCode = branchCodes;
      const response = await axios.post(
        "/losCustomer/getCustomerDataWithPage",
        filterCondition
      );
      let filterStateValue = { ...initialState };
      filterStateValue.branch = branchValue;
      filterStateValue.sanctionList = [...response.data.content];
      setFilterConditionState({ ...filterStateValue });
      dispatch(BranchAction.updateInitialLoad(false));
      dispatch(BranchAction.updateHeaderBranchDetails(branchValue));
    } else {
      resetFilterData();
    }
  };

  return (
    <>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <FilterCondition
          setAccordianOpen={setAccordianOpen}
          disDetailPage={true}
          mode={"Search"}
          initialState={filterConditionState}
          title="Disbursement Request Create"
          onSearchButtonClick={searchButtonClickHandler}
          onClearButtonClick={clearButtonClickHandler}
          initialOpen={true}
          onBranchChange={loadDataonBranchChange}
          listScreenMode="SANCTIONEDLIST"
          searchButtonRef={searchButtonRef}
          clearRef={clearRef}
        />
        <SanctionedList
          accordianOpenState={accordianOpen}
          onRowDoubleClick={rowDoubleClickHandler}
          data={filterConditionState.sanctionList}
          filterConditionState={filterConditionState}
        />
      </Box>
      <StlapFooter />
    </>
  );
};

export default DisbursementCreatePortal;
